import { render, staticRenderFns } from "./wxCallback.vue?vue&type=template&id=1378c333&scoped=true&"
import script from "./wxCallback.vue?vue&type=script&lang=ts&"
export * from "./wxCallback.vue?vue&type=script&lang=ts&"
import style0 from "./wxCallback.vue?vue&type=style&index=0&id=1378c333&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1378c333",
  null
  
)

export default component.exports